import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayout from 'src/layouts/MainLayout';
import type { RouteGroup } from '@martech-solution/utils/types';

const Login = lazy(() => import('src/pages/v2/Login'));
const SystemAdmin = lazy(() => import('src/pages/Home'));

export const commonRoutes: RouteGroup = [
  {
    path: urlPath.home.location,
    redirect: urlPath.systemAdmin.location
  },
  {
    path: urlPath.systemAdmin.location,
    Layout: MainLayout,
    Component: SystemAdmin
  },
  {
    path: '/login',
    Component: Login
  }
];
